import { Constantes } from "../constants/constantsGlobal";
import { iDriveMetadata } from "../models/drive";
import { iResponseType } from "../models/interfaceResponse";
import setupInterceptor from "./setupInterceptor";

export async function getDriveMetadata(
  url: string,
  user: any, 
  setUser: (user: any) => void
): Promise<iResponseType<iDriveMetadata>> {
  try {
    const encodedUrl = encodeURIComponent(url);
    const response = await setupInterceptor(`${Constantes.URI_DRIVE_METADATA}?url=${encodedUrl}`, user,setUser, {
          method: 'GET', 
           headers: {
            "Content-Type": "application/json",
          },
        });  
 

    if (!response.ok) {
      throw new Error("Error al obtener metadatos del archivo");
    }

    const data: iResponseType<iDriveMetadata> = await response.json();

    return data;

  } catch (error) {
    console.error("Error al consultar metadatos de Drive:", error);
    throw error;
  }
}

 